import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import MobileStepper from '@material-ui/core/MobileStepper';
import Paper from '@material-ui/core/Paper';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';

import indigo from '@material-ui/core/colors/indigo';
import red from '@material-ui/core/colors/red';

import { getIconName } from 'utils';
import icons from 'img/services';
import { ServiceIconsDialog } from 'components/admin/Dialogs';
import {
  startAddWebsiteService,
  startEditWebsiteService,
  startRemoveWebsiteService,
} from 'store/actions/website/index';
import { ConfirmDialog } from 'components/admin/Dialogs';

const styles = theme => ({
  avatar: {
    marginRight: theme.spacing.unit*2,
  },
  card: {
    marginTop: theme.spacing.unit*3,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    width: '400px',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
  },
  rootContent: {
    backgroundColor: indigo[50],
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    flexGrow: 1,
    marginRight: theme.spacing.unit,
  },
  iconContainer: {
    alignSelf: "center",
  },
  iconAvatar: {
    width: "140px",
    height: "140px",
    backgroundColor: indigo[300]
  },
  img: {
    alignSelf: 'center',
    height: '150px',
    width: '150px',
    overflow: 'hidden',
  },
  dialogActions: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  iconError: {
    display: "flex",
    justifyContent: "center",
    color: red[500],
  },
});


const validate = (service) => {
  const errors = {};
  const requiredFields = [ 'title', 'icon' ];
  requiredFields.forEach(field => {
    if (!service[field]) {
      errors[field] = 'Required';
    }
  });

  const validation = { errors, isInvalid: !!Object.keys(errors).length };
  validation.validateField = function (field) {
      return this.errors[field];
  };

  return validation;
}

class ServiceDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showIcons: false,
      showDelete: false,
    }
  }

  handleCancel = () => {
    this.setState({ showDelete: false });
  }

  handleDelete = () => {
    const { service, handleClose, startRemoveWebsiteService } = this.props;

    startRemoveWebsiteService(service.id)
      .then(() => handleClose());
  }

  render() {
    const {
      classes,
      theme,
      service,
      serviceIcons,
      handleClose,
      handleChange,
      startAddWebsiteService,
      startEditWebsiteService,
      startRemoveWebsiteService,
    } = this.props;
    const { showDelete, showIcons, showValidation, validation } = this.state;
    const type = service.id === undefined ? "add" : "edit";
    const icon = icons[service.icon] && icons[service.icon]["light-96"];

    console.log("SERVICE IN DIALOG:", service);
    return(
      <div>
        {showDelete &&
          <ConfirmDialog
            open={showDelete}
            title="Delete Service"
            contentText="This action will delete the service. Proceed?"
            handleCancel={this.handleCancel}
            handleOk={this.handleDelete}
          />
        }

        {showIcons &&
          <ServiceIconsDialog
            show={true}
            handleClose={() => this.setState({ showIcons: false })}
            handleSelect={(item) => {
              if (showValidation) {
                const validation = validate({ ...service, icon: item });
                this.setState({
                  showValidation: true,
                  validation,
                  showIcons: false
                });
              } else {
                this.setState({
                  showIcons: false
                });
              }
              handleChange("icon", item);
            }}
          />
        }

        <Dialog
          maxWidth="md"
          open={service === undefined ? false : true}
          onClose={handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle>
            <div className={classes.header}>
              <Avatar aria-label="Service" className={classes.avatar}>
                S
              </Avatar>
              <div>
                <Typography variant="subheading">
                  {type === "edit" ? "Edit Service" : "Add Service"}
                </Typography>
              </div>
            </div>
          </DialogTitle>
          <DialogContent classes={{root: classes.rootContent}}>
            <Card className={classes.card}>
              <CardContent className={classes.content}>
                <div className={classes.row}>
                  <TextField
                    error={(showValidation && !!validation.validateField("title"))}
                    helperText={(showValidation && validation.validateField("title"))}
                    className={classes.title}
                    label="Title"
                    placeholder="Enter title"
                    margin="normal"
                    value={service.title}
                    onChange={ event => {
                      if (showValidation) {
                        const validation = validate({ ...service, title: event.target.value });
                        this.setState({
                          showValidation: true,
                          validation
                        });
                      }

                      handleChange("title", event.target.value)
                    }}
                  />
                  <FormControlLabel
                    control={
                      <Switch
                        color="primary"
                        checked={service.show}
                        onChange={ () => handleChange("show", !service.show)}
                      />
                    }
                    label="Show"
                  />
                </div>

                <TextField
                  label="Description (optional)"
                  placeholder="Enter description"
                  margin="normal"
                  multiline
                  rows="4"
                  value={service.description}
                  onChange={ event => handleChange("description", event.target.value)}
                />
                {service.icon &&
                  <div
                    className={classes.iconContainer}
                    onClick={() => {
                      this.setState({ showIcons: true });
                    }}
                  >
                    <Avatar className={classes.iconAvatar}>
                      <img src={icon} />
                    </Avatar>
                  </div>
                }
                <Button
                  color="primary"
                  variant="outlined"
                  style={{ marginTop: '10px' }}
                  onClick={() => {
                    this.setState({ showIcons: true });
                  }}
                >
                  Select Icon
                </Button>
                { showValidation && !!validation.validateField("icon") &&
                  <Typography className={classes.iconError}>Icon Required</Typography>
                }
              </CardContent>
            </Card>
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Button onClick={() => this.setState({ showDelete: true })}>
              Delete
            </Button>
            <div>
              <Button onClick={handleClose} color="primary">
                Cancel
              </Button>
              <Button
                onClick={() => {
                  const validation = validate(service);
                  if (validation.isInvalid) {
                    this.setState({
                      showValidation: true,
                      validation,
                    });
                  } else {
                    if (type === "add") {
                      startAddWebsiteService(service)
                        .then(() => handleClose());
                    } else {
                      const { id, ...updates } = service;
                      startEditWebsiteService(id, updates)
                        .then(() => handleClose());
                    }
                  }
                }}
                color="primary">
                {type === "add" ? "Add" : "Done"}
              </Button>
            </div>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  serviceIcons: state.serviceIconsState,
});

const mapDispatchToProps = {
  startAddWebsiteService,
  startEditWebsiteService,
  startRemoveWebsiteService
}

export default compose(
  withStyles(styles, { withTheme: true }),
  connect(mapStateToProps, mapDispatchToProps)
)(ServiceDialog)



// WEBPACK FOOTER //
// ./src/components/admin/Website/Dialogs/ServiceDialog.jsx